(() => {
  const isCartPage = () => /\/cart\/?$/.test(location.pathname.toLowerCase());
  if (!isCartPage()) return;

  const fireEvents = (delay) => {
    setTimeout(() => {
      document.dispatchEvent(new Event('main-cart::refresh'));
      document.dispatchEvent(new Event('cart::add'));
    }, delay);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => fireEvents(1000), { once: true });
  } else {
    fireEvents(800);
  }

  document.addEventListener('click', (e) => {
    if (
      e.target.closest('.js-plus') ||
      e.target.closest('.js-minus') ||
      e.target.closest('.main-cart__line-item__remove')
    ) {
      fireEvents(500);
      fireEvents(800);
    }
  });
})();
